module.exports = __webpack_public_path__ + "static/img/253_TO8_2247_og.d22fa5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/253_TO8_2247_og.jpg
// module id = jZlD
// module chunks = 0